import { Component, input } from '@angular/core';

@Component({
  selector: 'app-loader',
  imports: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  readonly hide = input<boolean>(false);

  /** you must set class="loader-container" on encapsulating <div> in order to overlay only this particular <div>*/
  readonly displayAsOverlay = input<boolean>(false);
}
